import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { handleUnauthorized } from "../../utils/apiHelper";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";
import Loader from "../child/Loder";

const AddStorageSpaceTypePageNew = () => {
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = !!id;
  const authToken = localStorage.getItem("authToken");

  useEffect(() => {
    if (!isEditMode) return;

    const fetchSetting = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/admin/storageTypeById/${id}`,
          {
            method: "GET",
            headers: { Authorization: `Bearer ${authToken}` },
          }
        );

        if (response.status === 401) {
          handleUnauthorized(navigate);
          return;
        }

        const data = await response.json();
        if (response.ok) {
          setTitle(data.result.title || "");
        } else {
          setErrorMessage("Error fetching Types");
          clearMessage();
        }
      } catch (error) {
        setErrorMessage("Error fetching Types");
        clearMessage();
      } finally {
        setLoading(false);
      }
    };

    fetchSetting();
  }, [id, navigate]);

  const clearMessage = () => {
    setTimeout(() => {
      setSuccessMessage("");
      setErrorMessage("");
    }, 3000);
  };

  const validateInputs = () => {
    const newErrors = {};
    if (title.trim() === "") {
      newErrors.title = "Title is required";
    }
    if (!title) newErrors.title = "Title is required";
    setErrors(newErrors);
    if (title) {
      if (!/^[A-Za-z\s]+$/.test(title)) {
        newErrors.title = "Title must contain only alphabets";
      }
    }
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (!validateInputs()) {
      setLoading(false);
      return;
    }

    try {
      const method = isEditMode ? "PUT" : "POST";
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/${
        isEditMode ? `storageTypeUpdate/${id}` : "storageTypeAdd"
      }`;
      const title1 = title.trimEnd();
      const response = await fetch(API_ENDPOINT, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ title: title1, status: "active" }),
      });

      const data = await response.json();
      if (response.ok) {
        if (data.message == "This storage type already exists.") {
          setErrorMessage("This storage type already exists.");
          clearMessage();
        } else {
          setSuccessMessage(
            data.message || (isEditMode ? "Type Updated" : "Type Added")
          );
          clearMessage();
          setTimeout(() => navigate("/space-type"), 3000);
        }
      } else {
        setErrorMessage(data.message);
        clearMessage();
      }
    } catch (error) {
      setErrorMessage(error?.message || "Something went wrong");
      clearMessage();
    } finally {
      setLoading(false);
    }
  };

  // Show loader when loading
  if (loading) return <Loader />;

  return (
    <div className="row gy-4">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-header"></div>
          <div className="card-body">
            {successMessage && <SuccessAlert message={successMessage} />}
            {errorMessage && <DengerAlert message={errorMessage} />}
            <form
              className="row gy-3 needs-validation"
              noValidate
              onSubmit={handleSubmit}
            >
              <div className="col-md-12">
                <label className="form-label">
                  Title<span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.title ? "is-invalid" : ""}`}
                  id="title"
                  placeholder="Enter title"
                  value={title}
                  maxLength="40"
                  onChange={(e) => {
                    setTitle(e.target.value);
                    setErrors((prev) => ({ ...prev, title: "" }));
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/\s{2,}/g, " ")
                      .trimStart();
                  }}
                />
                {errors.title && (
                  <p className="text-danger mt-1">{errors.title}</p>
                )}
              </div>
              <div className="col-12">
                <button
                  className="btn btn-primary mt-3 float-end"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddStorageSpaceTypePageNew;
